var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.section.type == 'normal')?_c('NormalSectionView',_vm._g({attrs:{"section":_vm.buildSection,"uniqueId":_vm.uniqueId}},_vm.$listeners)):(_vm.section.type == 'toggle')?_c('ToggleableSectionView',{attrs:{"section":_vm.buildSection,"controls":_vm.controls,"uniqueId":_vm.uniqueId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }